/**
 * Normalize any thrown/rejected value into an Error instance so Sentry and
 * logging always receive a stack-bearing object instead of undefined/null.
 */
export const toError = (reason, fallbackMessage = 'Unknown error') => {
  if (reason instanceof Error) {
    return reason;
  }

  if (reason === undefined || reason === null) {
    return new Error(fallbackMessage);
  }

  if (typeof reason === 'string') {
    return new Error(reason);
  }

  try {
    return new Error(JSON.stringify(reason));
  } catch (e) {
    return new Error(String(reason));
  }
};

export default toError;
